import { IBonus } from '@/src/assets/interfaces/bonusInterface';
import React, { FC, useRef } from 'react';
import Link from 'next/link';
import imageHelper from '@/src/assets/helpers/imageHelper';
import styles from './PortableBonusCard.module.scss';
import PortableBlock from '../UI/portableBlock/PortableBlock';
import ButtonsGroup from '../buttonsGroup/ButtonsGroup';
import NextImage from '../UI/nextImage/NextImage';
import returnValidDate from '@/src/assets/helpers/returnValidDate';

type TCardData = {
  cardData: Partial<IBonus>;
};

const PortableBonusCard: FC<TCardData> = ({ cardData }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { bonusText, code, description, logo, vendorName, slug, codeUrl, shortUrl } = cardData;

  const date = new Date();

  return (
    <>
      {cardData && (
        <div className={styles.card}>
          <div className={styles.card__left}>
            <div className={styles.card__logo__container}>
              <div className={styles.card__logo}>
                <NextImage
                  src={imageHelper(logo).url}
                  alt={imageHelper(logo).alt ?? 'Bonus Logo'}
                  width={60}
                  height={60}
                />
              </div>
              <Link className={styles.vendor__link} href={`/bonuses/${slug}`}>
                {vendorName}
              </Link>
            </div>
            <div className={styles.card__info}>
              <div className={styles.card__text}>{bonusText}</div>
              {code && (
                <div className={styles.valid}>{`Bonus Code ${code} Valid Today: ${returnValidDate(
                  date
                )}`}</div>
              )}
              <div className={styles.card__bottom}>
                <PortableBlock value={description} />
              </div>
            </div>
          </div>

          <div className={styles.card__right}>
            <ButtonsGroup
              className={`${styles.buttons} ${!code && styles.no__code}`}
              url={codeUrl!}
              code={code!}
              inputRef={inputRef}
              shortUrl={shortUrl!}
            />

            {vendorName && (
              <Link href={`/bonuses/${slug}`} className={styles.link}>
                More About {vendorName} Bonus Code
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                  fill="none">
                  <path d="M9.47868 7.3334L6.33468 3.75747L7.16359 2.81467L11.7226 8.00007L7.16359 13.1855L6.33468 12.2427L9.47868 8.66673L2.34454 8.66673L2.34454 7.3334L9.47868 7.3334Z" />
                </svg>
              </Link>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PortableBonusCard;
